module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAABNUlEQVQ4T53SMUrEQBgF4PdGYquNnaAJ9p7AImppvVmLZTFj0NoDiNZi7SIbFQuTiHoAvYqsTcArSNzklyTsLkhWJk79/o/3zwxhcNb8xF1Q8grgMxO1nYad96YxGlhY1w99RXVXZ5lmQrcJNMJKwtHxAMTRX6AxVoFBPIBMQEkzGbtp2Juu3AqrwMPoCuDxrGE2BVtjJWLr6ALkCQEFzBpy4+BxJVfFJYllk8eoMoJvAHsgFusZSYsxtujo+BTEuTE0N8gz2n68SSIRYAmkmKHyRcgqQKsuilxytfOvO3N05IMcALBKiEBnNOy+tMZsPwqoeD1pxILe6MZ7rr6z2Vp1yu5HmhaHTVArzNGJD0o4DzLGnCDZhchbDUmBHN7H7f7T762M1rR11CN5L4IchXSboBL+AcivhG/KAfT8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/leftarrow.png
// module id = fUSw
// module chunks = 3